import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appTwoDigitDecimalNumber]',
  standalone: false,
})
export class TwoDigitDecimaNumberDirective {
  // Allow decimal numbers and negative values
  private regex = new RegExp(/^\d*\.?\d{0,2}$/g);
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: string[] = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    '-',
    'ArrowLeft',
    'ArrowRight',
    'Del',
    'Delete',
  ];

  constructor(private el: ElementRef) {}
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const inputVal = (event.currentTarget as HTMLInputElement)['value'];
    const hasComma = inputVal.includes(',');
    if (hasComma) {
      (event.currentTarget as HTMLInputElement).maxLength = 7;
    } else {
      (event.currentTarget as HTMLInputElement).maxLength = 6;
    }
    const next: string = [
      current.slice(0, position),
      event.key == 'Decimal' ? '.' : event.key,
      current.slice(position),
    ]
      .join('')
      .replace(',', '');

    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
